import React, { useState } from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { RiRefreshLine } from "react-icons/ri";

import Button, { Color } from "../../../../../../../components/Form/Button";
import { ConfirmCancelModal } from "./ConfirmModal";
import useStyles from "./styles";

interface Props {
  isLoading: boolean;
  changeHasBeenMade: boolean;
  handleGetOldCompanyInfo: () => void;
  handleUpdateCompany: () => void;
}

const FooterActions = ({
  isLoading,
  changeHasBeenMade,
  handleGetOldCompanyInfo,
  handleUpdateCompany,
}: Props) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  const [openModal, setOpenModal] = useState<boolean>(false);

  return (
    <>
      <Grid
        container
        direction="row"
        alignItems="flex-end"
        justifyContent="space-between"
        className={classes.sectionWrapper}
      >
        <Grid item container direction="column" md={6} lg={6} justifyContent="flex-start">
          {false && (
            <>
              <label className={classes.sectionTitle}>{translate("actions")}</label>
              <Button
                customColor={Color.ERROR}
                data-cy="generalInactiveButton"
                className={classes.buttonInactive}
              >
                <RiRefreshLine className={classes.buttonInactiveIcon} />
                {translate("inactiveCompany")}
              </Button>
            </>
          )}
        </Grid>
        <Grid item container direction="row" md={6} lg={6} justifyContent="flex-end">
          <Button
            customColor={Color.CANCEL}
            data-cy="generalCancelButton"
            onClick={() => setOpenModal(true)}
            disabled={!changeHasBeenMade}
          >
            {translate("cancel")}
          </Button>
          <Button
            customColor={Color.SUCCESS}
            data-cy="generalSaveButton"
            onClick={handleUpdateCompany}
            disabled={isLoading}
          >
            {translate("save")}
          </Button>
        </Grid>
      </Grid>
      <ConfirmCancelModal
        open={openModal}
        closeModal={() => setOpenModal(false)}
        undoChanges={handleGetOldCompanyInfo}
      />
    </>
  );
};

export default FooterActions;
